import { Routes } from '@angular/router';
import { MediaCenterComponent } from './media-center.component';
import { MediaCenterType01Component } from './media-center-type01/media-center-type01.component';

export default [
    {
        path     : '',
        // component: MediaCenterComponent,
        component: MediaCenterType01Component
    },
    
] as Routes;
